<template>
  <div class="news-detail-container">
    <div class="news-detail-main-body" v-if="detail">
      <div class="body__back-bt scrollObj" @click="$router.go(-1)">
        <div class="animation-line"></div>
        <p>back</p>
      </div>
      <div class="body__main-content-container">
        <div class="bmcc__fixed-part scrollObj">
          <img :src="detail.inner_big_img" alt="" ref="opImg" />
        </div>
        <div class="bmcc__main-content" ref="cWrapper">
          <div class="content__inner">
            <div class="content__title">
              <p class="content__publish scrollObj">{{ detail.publish }}</p>
              <p class="title__text scrollObj">{{ detail.title }}</p>
            </div>
            <div class="content__main-body" v-if="detail.content">
              <div
                class="scrollObj"
                v-for="(content, index) in detail.content"
                :key="index"
                :class="{
                  text: content.type === 'textarea',
                  img: content.type === 'img',
                  multi: content.type === 'scroll'
                }"
                v-html="renderHtml(content)"
              ></div>
            </div>
          </div>
        </div>
      </div>
      <div class="body__other-container">
        <div class="other__item">
          <template v-if="prev">
            <router-link
              :to="{
                path: `/news/${encodeURIComponent(prev.title)}/${prev.id}`
              }"
            >
              <div class="item__cover scrollObj">
                <img :src="prev.inner_big_img" alt="" />
              </div>
              <div class="item__text scrollObj">
                <p>{{ prev.publish }}</p>
                <p>{{ prev.title }}</p>
              </div>
            </router-link>
          </template>
        </div>
        <div class="other__item" v-if="next">
          <router-link
            :to="{
              path: `/news/${encodeURIComponent(next.title)}/${next.id}`
            }"
          >
            <div class="item__cover scrollObj">
              <img :src="next.inner_big_img" alt="" />
            </div>
            <div class="item__text scrollObj">
              <p>{{ next.publish }}</p>
              <p>{{ next.title }}</p>
            </div>
          </router-link>
        </div>
      </div>
    </div>
    <page-footer class="common-footer"></page-footer>
  </div>
</template>

<script>
import { newsDetail } from '@/utils/data';
import pageFooter from '../common/footer.vue';

export default {
  name: 'page-news-detail',
  components: {
    pageFooter,
  },
  data() {
    return {
      other: [
        {
          cover: require('@/assets/images/wd/d1/news/detail/p1.png'),
          publish: 'October.12.2020',
          title: '家具 | 全新艺术家具亮相大师先锋联展，呈现冰川流动之美',
        },
        {
          cover: require('@/assets/images/wd/d1/news/detail/n1.png'),
          publish: 'July.13.2020',
          title: '奖讯 | WJID作品【龙湖.天璞售楼处】入选2020德国红点设计大奖',
        },
      ],
      isTriggerScroll: false,
      detail: null,
      next: null,
      prev: null,
    };
  },
  computed: {
    offsetTop() {
      return parseFloat(
        window.getComputedStyle(document.querySelector('.header-main-container')).paddingTop,
      );
    },
    totalHeight() {
      return parseFloat(this.$refs.cWrapper.getBoundingClientRect().height);
    },
  },
  mounted() {
    const that = this;
    that.$nextTick(() => {
      window.addEventListener('scroll', this.onScroll);
    });
  },
  destroyed() {},
  beforeRouteEnter(to, from, next) {
    newsDetail(to.params.id).then((res) => {
      next((vm) => {
        vm.setData(res);
      });
    });
  },
  beforeRouteUpdate(to, from, next) {
    newsDetail(to.params.id).then((res) => {
      this.setData(res);
      next();
    });
  },
  methods: {
    onScroll() {
      this.isTriggerScroll = true;
      if (this.$refs.cWrapper && !this.$bowser.mobile) {
        // eslint-disable-next-line max-len
        const scrollTop = parseFloat(this.$refs.cWrapper.getBoundingClientRect().top * 1.2) - this.offsetTop;
        const opacity = scrollTop < 0 ? 1 - Math.abs(scrollTop / this.totalHeight) : 1;
        this.$refs.opImg.style.cssText = `opacity:${opacity}`;
      }
    },
    setData(data) {
      this.detail = data.detail;
      this.next = data.next;
      this.prev = data.prev;
    },
    renderHtml(content) {
      if (content.type === 'textarea') {
        return content.value;
      }
      if (content.type === 'scroll') {
        let html = '';
        for (let i = 0; i < content.value.length; i += 1) {
          html += `<div class="scroll__img"><img src="${content.value[i]}" /></div>`;
        }
        return html;
      }
      return `<img src="${content.value}" />`;
    },
  },
};
</script>

<style></style>
